import { BarChartOutlined } from '@ant-design/icons/lib';
import { Route, RouteGroup } from '@models/classes';
import { MenuPlacement } from '@models/enums';
import { ReportsBrowse } from './components/reports-browse';
import { ReportsGuard } from './models/reports.guard';

export const reportsRoutes = new RouteGroup({
  name: 'Reports',
  path: '/reports',
})
  .setMenu(MenuPlacement.Main, BarChartOutlined)
  .breadcrumb()
  .addGuard(new ReportsGuard(), '/')
  .addRoute(
    new Route({ path: '/browse', name: 'Browse', component: ReportsBrowse })
      .setMenu(MenuPlacement.Main)
      .addGuard(new ReportsGuard(), '/')
      .breadcrumb(),
  );
